import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

const NoteStyles = styled.div`
  margin: 5px 0 0 5px;
  label {
    display: inline;
  }
`;
const ServiceNote = ({ note }) =>
  note ? (
    <Row>
      <Col md={12}>
        <NoteStyles>
          <label htmlFor="123">Service Note:</label> {note}
        </NoteStyles>
      </Col>
    </Row>
  ) : null;

ServiceNote.propTypes = {
  note: PropTypes.string
};
export default ServiceNote;
